var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 20.25H7.875C8.2125 20.25 8.4375 20.1375 8.6625 19.9125L21.0375 7.5375C21.4875 7.0875 21.4875 6.4125 21.0375 5.9625L16.5375 1.4625C16.0875 1.0125 15.4125 1.0125 14.9625 1.4625L2.5875 13.8375C2.3625 14.0625 2.25 14.2875 2.25 14.625V19.125C2.25 19.8 2.7 20.25 3.375 20.25ZM4.5 15.0749L15.75 3.82487L18.675 6.74987L7.425 17.9999H4.5V15.0749ZM23.625 25.875C24.3 25.875 24.75 25.425 24.75 24.75C24.75 24.075 24.3 23.625 23.625 23.625H3.375C2.7 23.625 2.25 24.075 2.25 24.75C2.25 25.425 2.7 25.875 3.375 25.875H23.625Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "edit",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 23,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 20.25H7.875C8.2125 20.25 8.4375 20.1375 8.6625 19.9125L21.0375 7.5375C21.4875 7.0875 21.4875 6.4125 21.0375 5.9625L16.5375 1.4625C16.0875 1.0125 15.4125 1.0125 14.9625 1.4625L2.5875 13.8375C2.3625 14.0625 2.25 14.2875 2.25 14.625V19.125C2.25 19.8 2.7 20.25 3.375 20.25ZM4.5 15.0749L15.75 3.82487L18.675 6.74987L7.425 17.9999H4.5V15.0749ZM23.625 25.875C24.3 25.875 24.75 25.425 24.75 24.75C24.75 24.075 24.3 23.625 23.625 23.625H3.375C2.7 23.625 2.25 24.075 2.25 24.75C2.25 25.425 2.7 25.875 3.375 25.875H23.625Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#edit)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.5b1b954b58c4d6881d6f0065bbff8935.svg";
export { ForwardRef as ReactComponent };